import React, { useEffect, useRef, useState } from "react";
import { TextAreaWithLimit } from "../../Components";
import ExampleBrief from "../../Components/ExampleBrief";

import { briefService } from "../../Services/brief.service";
export default function AddBrief({
  setGeneratedBriefResponse,
  setTab,
  setToastList,
  toastList,
}) {
  const createList = useRef(null);
  const [form, setForm] = useState({
    brief: "",
  });
  console.log(form);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [isError, setIsError] = useState(false);
  //const [toastList, setToastList] = useState([]);
  const [disableCreateButton, setDisableCreateButton] = useState(false);
  const [showExampleModal, setShowExampleModal] = useState(false);
  const updateForm = (data) => {
    setForm({ ...form, ...data });
  };
  const setInput = (key) => (event) => {
    //setError
    // setErrorText("");
    setError(false);
    updateForm({ [key]: event.target.value });
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    if (data.msg) {
      if (data.msg[data.msg.length - 1] === ".")
        data.msg = data.msg.slice(0, -1);
    }
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };
  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        createList.current.click();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [form, isError]);
  const validateBrief = async () => {
    setIsError(!isError);
    console.log(form.brief.length);
    setErrorText("");
    if (
      form.brief === "" ||
      form.brief.length < 500 ||
      form.brief.length > 5000
    ) {
      setError(true);
    } else {
      setError(false);
      setErrorText("");
      try {
        let param = {
          description: form.brief,
        };
        console.log(param);
        const res = await briefService.createBrief(param);
        console.log("in Breaf", res);
        if (res.success === true) {
          setGeneratedBriefResponse(res.data);
          setTab("savebrief");
        }
      } catch (err) {
        addToast({
          error: true,
          date: new Date(),
          msg:
            typeof err === "string" ? err.replace(/<[^>]*>/g, "") : err.message,
        });
        //setTabModal("main")
      }
    }
  };

  const handleUseExample = (exampleText) => {
    setForm({ ...form, brief: exampleText });
    setError(false);
  };
  return (
    <>
      <div className="assetsAdd__form">
        <div className="assetsAdd__form-title">
          <h6 className="small"></h6>
        </div>
        <div className="assetsAdd__form-inner">
          <div className="assetsAdd__form-head briefBox">
            <TextAreaWithLimit
              value={form.brief}
              label="How would you briefly describe Your project ?"
              onChange={setInput("brief")}
              error={error}
              autoFocus
              errorText={
                "Please enter brief. It should be between 500 chracters to 5000"
              }
              placeholder="Enter brief"
              isError={isError}
              row="20"
            />
          </div>
        </div>

        <div className="campaignsCreate__btns">
          <button
            className=" rounded-xl border-2 border-green-700 text-gray-700 bg-green-50 p-2 leading-[1] text-center  py-[13px]"
            onClick={() => setShowExampleModal(true)}
          >
            Example Brief
          </button>{" "}
          <button className="button primary" onClick={validateBrief}>
            Generate Brief
          </button>
        </div>
      </div>

      <ExampleBrief
        isOpen={showExampleModal}
        onClose={() => setShowExampleModal(false)}
        onUseExample={handleUseExample}
      />
    </>
  );
}
